import * as React from 'react';
import { TopBanner } from '../../../components/OfferComplain/';
import { jsx as _jsx } from "react/jsx-runtime";
export var OfferComplaintTopBannerContainer = function OfferComplaintTopBannerContainer() {
  return /*#__PURE__*/_jsx(TopBanner, {});
};